<template>
    <v-card flat>
        <v-card-title >
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                class="custom-table custom-table__header"
                :headers="headers"
                :items="iabVendorsByWebsiteData"
                :loading="loading"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                @update:sort-desc="handleSortDesc"
                @update:sort-by="handleSortBy"
                hide-default-footer
        >
            <template v-slot:no-data> NO DATA </template>
        </v-data-table>
        <v-row class="align-center" v-if="iabVendorsByWebsiteData.length">
            <v-col cols="12" sm="11" >
                <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="7"
                        @input="onChangePagination"
                ></v-pagination>
            </v-col>
            <v-col cols="12" sm="1">
                <v-select
                        :value="10"
                        :items="[5, 10, 15, 'All']"
                        label="Items per page"
                        @change="handleItemsPerPage"
                        hint="Items per page"
                        persistent-hint
                ></v-select>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    import { createNamespacedHelpers } from "vuex";
    const adminDashboardHelper = createNamespacedHelpers("adminDashboard");
    export default {
        name: 'IabVendorsByWebsite',
        computed:{
            ...adminDashboardHelper.mapGetters(["getIabVendorsByWebsite", "getSelectedWebsite"]),
        },
        data () {
            return {
                search: '',
                headers: [
                    { text: 'IAB Name', align: 'start', value: 'iab_name' },
                    { text: 'IAB ID', value: 'iab_id', sortable: false },
                    { text: 'IAB Version', value: 'spec_version', sortable: false },
                ],
                iabVendorsByWebsiteData: [],
                loading: true,
                page: 1,
                pageCount: 1,
                itemsPerPage: 10,
                totalCount: 1,
                sortDesc: true,
                sort_field: "iab_name",
            }
        },
        methods: {
            ...adminDashboardHelper.mapActions([ "fetchIabVendorsByWebsite"]),
            async getIabVendorsByWebsiteDashboard(){
                this.loading = true;
                await this.fetchIabVendorsByWebsite({
                    website_id: this.getSelectedWebsite,
                    page: this.page,
                    page_size: this.itemsPerPage < 0 ? this.pageCount : this.itemsPerPage,
                    sort: this.sortDesc ? "asc" : "desc",
                    s: this.search,
                    sort_field: this.sort_field ? 'iabvendor.' + this.sort_field : 'iabvendor.iab_name'
                });
                this.loading = false;
            },
            handleItemsPerPage(itemsPerPage){
                this.page = 1;
                if(itemsPerPage === 'All'){
                    this.itemsPerPage = this.totalCount;
                } else {
                    this.itemsPerPage = itemsPerPage;
                }
                this.getIabVendorsByWebsiteDashboard();
            },
            handleSortDesc(desc){
                if( this.sortDesc !== desc[0] && desc.length){
                    this.sortDesc = desc[0];
                    this.getIabVendorsByWebsiteDashboard();
                }
            },
            handleSortBy(sortBy){
                if(this.sort_field !== sortBy[0] && sortBy.length){
                    this.sort_field = sortBy[0];
                    this.getIabVendorsByWebsiteDashboard();
                }
            },
            onChangePagination(){
                this.getIabVendorsByWebsiteDashboard();
            },
        },
        created () {
            this.loading= false;
            if(this.getSelectedWebsite){
                this.getIabVendorsByWebsiteDashboard();
            }
        },
        watch: {
            getIabVendorsByWebsite: function(e){
                this.iabVendorsByWebsiteData = e.results;
                this.pageCount = Math.ceil(e.count/this.itemsPerPage);
                this.totalCount = e.count;
            },
            search: function(){
                this.page = 1;
                this.getIabVendorsByWebsiteDashboard();
            },
            getSelectedWebsite: function(website) {
                if(website){
                    this.getIabVendorsByWebsiteDashboard();
                }
            },
        }
    }
</script>
